module.exports = __webpack_public_path__ + "img/image-empty.23124cf4.png";